
import React from 'react';
import { Nav, Container } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom';
import './components.css';

const SideBar = () => {
  return (
    <div id="sidebar-container" class="sidebar-expanded d-none d-md-block col-2">
        {/* d-* hiddens the Sidebar in smaller devices. Its itens can be kept on the Navbar 'Menu' */}
        {/* Bootstrap List Group */}
        <ul class="list-group sticky-top sticky-offset">
            {/* Separator with title */}
            <li class="list-group-item sidebar-separator-title text-muted d-flex align-items-center menu-collapsed">
                <small>Solutions</small>
            </li>
            {/* /END Separator */}
            {/* Menu with submenu */}
            <Link to="/solutions/1-10" aria-expanded="false" class="bg-dark list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-start align-items-center">
                    <span class="menu-collapsed">Solution 1 - 10</span>
                </div>
            </Link>

            <a href="#submenu2" data-toggle="collapse" aria-expanded="false" class="bg-dark list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-start align-items-center">
                    <span class="menu-collapsed more">More </span> 
                    <span class="fa fa-caret-down"> </span>
                </div>
            </a>
            {/* Submenu content */}
            <div id="submenu2" class="collapse sidebar-submenu">
                <a href="#" class="list-group-item list-group-item-action bg-dark text-white">
                    <span class="menu-collapsed">Components</span>
                </a>
                <a href="https://projecteuler.net" target="_blank" class="list-group-item list-group-item-action bg-dark text-white">
                    <span class="menu-collapsed">Go to Project Euler</span>
                </a>
            </div>
            {/* Separator without title */}
            <li class="list-group-item sidebar-separator menu-collapsed"></li>
            {/* /END Separator */}
            <a href="#" class="bg-dark list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-start align-items-center">
                    <span class="menu-collapsed">Contact</span>
                </div>
            </a>
        </ul>
        {/* List Group END*/}
    </div>
  )
}

export default SideBar